import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { pages } from 'config/pages';
import { Footer, CookieInfo, AwwwardsRibbon, SEO } from '.';
import { getCloudinaryUrl } from 'config/helpers';
import 'styles/main.scss';

class TemplateWrapper extends Component {
  render() {
    const { children, page, cloudinary } = this.props;

    let pathBase = null;

    if (typeof window !== 'undefined' && window.location) {
      const { pathname } = window.location;
      pathBase = pathname.split('/')[1];
    }

    const { canonical } = this.props || page || pages.default;
    const { footer, siteTitle, siteContent, siteCover } = page || pages.default;

    return (
      <div>
        <SEO
          title={siteTitle}
          description={siteContent}
          cover={getCloudinaryUrl(siteCover, 'f_auto,q_auto')}
          slug={pathBase}
          canonical={canonical}
        />
        <AwwwardsRibbon />
        <div>{children}</div>
        {footer && <Footer />}
        <CookieInfo />
      </div>
    );
  }
}

TemplateWrapper.defaultProps = {
  cloudinary: false,
};

TemplateWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.object.isRequired,
  canonical: PropTypes.string,
  cloudinary: PropTypes.bool,
};

export default TemplateWrapper;
